import { CLUSTER } from '../../../constants';
import cssResets from '../../../constants/cssResets';
import { windowLoad } from './windowLoad';
import islandMock from '../../../constants/island-mock';

function BFPContentObject(props) {
  const { content, contentObjectId, mockIslandApp, ownerProfile, renderKitUrl } = props;
  const bfp = content.bfp;

  // initial server HTML for body
  const serverRender = bfp?.renders?.oo_web;

  const fields = {
    env: CLUSTER,
    renderKitUrl,
    bfpId: bfp.id,
    bfpFormatName: bfp.format_name,
    bfpData: bfp.data,
    contentObjectId,
    context: {
      env: CLUSTER,
      clientEventTracking: {},
      contentObjectId,
      contentObject: { content, id: contentObjectId, ownerProfile },
      bfpId: bfp.id
    }
  };

  const initScript = `
    function getCookie(name) {
      const re = new RegExp(name + '=([^;]+)');
      const value = re.exec(document.cookie);
      return unescape((value === null || value === void 0 ? void 0 : value[1]) || '');
    }
    function isEnhancedCETSupported() {
      return window.BZFD_APP && window.BZFD_APP.feature_support && window.BZFD_APP.feature_support.cet;
    }
    function getCETSource() {
      const isEnhanced = isEnhancedCETSupported();
      if (isEnhanced) {
        return 'island_app_v3';
      }
      return 'web_island';
    }
    ${windowLoad}
    window.onload = windowLoad({ fields: ${JSON.stringify(fields)}, islandMock: ${mockIslandApp ? JSON.stringify(islandMock) : null} });
  `;

  return (
    <html>
      <head>
        <style>
          {cssResets}
        </style>
        <script dangerouslySetInnerHTML={{ __html: initScript }} />
        <meta id="viewport" name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, viewport-fit=cover" />
        <meta name="robots" content="noindex, nofollow" />
      </head>
      <body>
        <script
          data-name="tracking-data"
          type="application/json"
          id={`bfp-${bfp.id}-${contentObjectId}-tracking`}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({})
          }}
        />
        <div
          dangerouslySetInnerHTML={{ __html: serverRender ? serverRender : '' }}
          id={`bfp-${bfp.id}-${contentObjectId}`}
        />
      </body>
    </html>
  );
}

export default BFPContentObject;
